module.exports = __webpack_public_path__ + "img/app-pornhub2.a80436a0.webp";